import type { RequestStatus } from '../types/app';

export const STATUS_COLORS: Record<
  RequestStatus,
  { bg: string; text: string; border: string; dot: string }
> = {
  Pending: {
    bg: 'bg-warning-bg',
    text: 'text-warning',
    border: 'border-warning',
    dot: 'bg-warning',
  },
  Quoted: {
    bg: 'bg-info-bg',
    text: 'text-info',
    border: 'border-info',
    dot: 'bg-info',
  },
  Accepted: {
    bg: 'bg-success-bg',
    text: 'text-success',
    border: 'border-success',
    dot: 'bg-success',
  },
  Assigned: {
    bg: 'bg-info-bg',
    text: 'text-info',
    border: 'border-info',
    dot: 'bg-info',
  },
  EnRoute: {
    bg: 'bg-accent-bg',
    text: 'text-accent',
    border: 'border-accent',
    dot: 'bg-accent',
  },
  Loading: {
    bg: 'bg-accent-bg',
    text: 'text-accent',
    border: 'border-accent',
    dot: 'bg-accent',
  },
  InTransit: {
    bg: 'bg-accent-bg',
    text: 'text-accent',
    border: 'border-accent',
    dot: 'bg-accent',
  },
  Delivered: {
    bg: 'bg-success-bg',
    text: 'text-success',
    border: 'border-success',
    dot: 'bg-success',
  },
  Cancelled: {
    bg: 'bg-danger-bg',
    text: 'text-danger',
    border: 'border-danger',
    dot: 'bg-danger',
  },
  Disputed: {
    bg: 'bg-danger-bg',
    text: 'text-danger',
    border: 'border-danger',
    dot: 'bg-danger',
  },
};
